import Amazon from '../../../../assets/image/Couriers/Integrations/AmazonLogo1.png';
import Bluedart from '../../../../assets/image/Couriers/Integrations/Bluedart.png';
import Delhivery from '../../../../assets/image/Couriers/Integrations/Delhivery.png';
import Dtdc from '../../../../assets/image/Couriers/Integrations/DtdcLogo.png';
import Ecom from '../../../../assets/image/Couriers/Integrations/EcomExpressLogo.png';
import Ekart from '../../../../assets/image/Couriers/Integrations/Ekart1.png';
import Pickndel from '../../../../assets/image/Couriers/Integrations/pickAndDelLogo.png';
import Professional from '../../../../assets/image/Couriers/Integrations/Professional.png';
import Shadowfax from '../../../../assets/image/Couriers/Integrations/ShadowFax.png';
import Smartr from '../../../../assets/image/Couriers/Integrations/SmartRIcon.png';
import Smc from '../../../../assets/image/Couriers/Integrations/ShreeMarutiLogo.png';
import Xpressbees from '../../../../assets/image/Couriers/Integrations/XpressBees1.png';
import Gati from '../../../../assets/image/Couriers/Integrations/GatiLogo.png';
import FedEx from '../../../../assets/image/Couriers/Integrations/FedexLogo.png';
import Dhl from '../../../../assets/image/Couriers/Integrations/DhlLogo.png';
import Movin from '../../../../assets/image/Couriers/Integrations/MovinLogo.png';
import Xindus from '../../../../assets/image/Couriers/Integrations/XindusLogo.png';

export const courierPartners = [
    {
        "id": 1,
        "name": "XpressBees",
        "image": Xpressbees,
        "tagline": "Fast and reliable logistics solutions",
        "features": [
            "Next-day delivery",
            "Real-time tracking",
            "Affordable shipping rates"
        ]
    },
    {
        "id": 2,
        "name": "Delhivery",
        "image": Delhivery,
        "tagline": "India’s leading logistics partner",
        "features": [
            "Pan-India coverage",
            "Customized solutions",
            "Same-day delivery"
        ]
    },
    {
        "id": 3,
        "name": "Ecom Express",
        "image": Ecom,
        "tagline": "Speed meets reliability",
        "features": [
            "Express delivery",
            "Flexible pickup options",
            "E-commerce logistics expertise"
        ]
    },
    {
        "id": 4,
        "name": "Shadowfax",
        "image": Shadowfax,
        "tagline": "On-demand delivery redefined",
        "features": [
            "Hyperlocal delivery",
            "Fast turnarounds",
            "Multi-category logistics"
        ]
    },
    {
        "id": 5,
        "name": "Blue Dart",
        "image": Bluedart,
        "tagline": "Delivering excellence since 1983",
        "features": [
            "Global shipping",
            "Premium express service",
            "Reliable returns management"
        ]
    },
    {
        "id": 6,
        "name": "FedEx",
        "image": FedEx,
        "tagline": "Connecting people with goods worldwide",
        "features": [
            "International logistics",
            "Customs clearance expertise",
            "Door-to-door delivery"
        ]
    },
    {
        "id": 7,
        "name": "DTDC",
        "image": Dtdc,
        "tagline": "Logistics simplified",
        "features": [
            "Domestic and international delivery",
            "Wide coverage across India",
            "Economical shipping options"
        ]
    },
    {
        "id": 8,
        "name": "Amazon Shipping",
        "image": Amazon,
        "tagline": "Fast, reliable delivery for businesses",
        "features": [
            "Amazon Prime fast delivery",
            "Integrated logistics solutions",
            "Real-time shipment updates"
        ]
    },
    {
        "id": 9,
        "name": "Gati",
        "image": Gati,
        "tagline": "India’s pioneer in express distribution",
        "features": [
            "Freight services",
            "Warehousing solutions",
            "Time-definite delivery"
        ]
    },
    {
        "id": 10,
        "name": "Pickndel",
        "image": Pickndel,
        "tagline": "The ultimate local delivery service",
        "features": [
            "Efficient last-mile delivery",
            "Real-time updates",
            "Tailored solutions for businesses"
        ]
    },
    {
        "id": 11,
        "name": "Smartr Logistics",
        "image": Smartr,
        "tagline": "Redefining logistics with innovation",
        "features": [
            "Smart logistics solutions",
            "Tech-driven services",
            "End-to-end delivery management"
        ]
    },
    {
        "id": 12,
        "name": "Movin",
        "image": Movin,
        "tagline": "Smart moves for smarter businesses",
        "features": [
            "Express parcel service",
            "Collaborative supply chain",
            "Reliable and fast deliveries"
        ]
    },
    {
        "id": 13,
        "name": "DHL",
        "image": Dhl,
        "tagline": "Excellence. Simply delivered.",
        "features": [
            "Global presence",
            "Logistics innovation",
            "Customs expertise"
        ]
    },
    {
        "id": 14,
        "name": "SMC (Shree Maruti Courier)",
        "image": Smc,
        "tagline": "Connecting India through logistics",
        "features": [
            "Domestic courier services",
            "Affordable pricing",
            "Quick and efficient deliveries"
        ]
    },
    {
        "id": 15,
        "name": "Professional Couriers",
        "image": Professional,
        "tagline": "The professionals in courier services",
        "features": [
            "Wide network coverage",
            "Priority delivery options",
            "Strong customer support"
        ]
    },
    {
        "id": 16,
        "name": "Ekart",
        "image": Ekart,
        "tagline": "Leading the e-commerce logistics space",
        "features": [
            "Same-day and next-day delivery",
            "End-to-end logistics support",
            "High customer satisfaction"
        ]
    },
    {
        "id": 17,
        "name": "Xindus",
        "image": Xindus,
        "tagline": "Innovative logistics solutions",
        "features": [
            "Customized delivery options",
            "Flexible pickup timings",
            "Trusted by leading businesses"
        ]
    }
]